import React from 'react';

import { CallToActionSideBlock } from '@sravni/react-ugc/lib/CallToActionSideBlock';
import { createReviewLink, OrganizationType as TOrganization } from '@sravni/utils/lib/createReviewLink';

import { OrganizationType, OrganizationTypeToReviewsServiceMap } from '../../constants/organizationType';
import { sendGoToWriteReviewEvent } from '../../helpers/analyticsEvents';
import { useOrganizationType } from '../../hooks/organizationType';

const textMap = {
  [OrganizationType.BANK]: 'Расскажите о своём опыте использования банковских услуг',
  [OrganizationType.INSURANCE]: 'Расскажите о своём опыте использования страховых услуг',
  [OrganizationType.MFI]: 'Расскажите о своём опыте использования услуг микрофинансовых организаций',
  [OrganizationType.COURSES]: 'Расскажите о своём опыте обучения',
  [OrganizationType.BROKER]: 'Расскажите о своём опыте использования брокерских услуг',
  [OrganizationType.NPF]: 'Расскажите о своём опыте использования негосударственных пенсионных фондов',
  [OrganizationType.BANKRUPTCY]: 'Расскажите о своем опыте использования услуг по банкротству физических лиц',
  [OrganizationType.BOOKMAKER]: 'Расскажите о своём опыте использования букмекерских услуг',
  [OrganizationType.UNIVERSITY]: 'Расскажите о своём опыте обучения',
  [OrganizationType.FOOD_RATION]: 'Расскажите о своём опыте использования услуг сервисов готовых рационов',
};

export const GiveFeedback = React.memo(() => {
  const organizationType = useOrganizationType();

  const handleClick = () =>
    sendGoToWriteReviewEvent({
      organizationType,
    });

  const link = createReviewLink({
    organizationType: OrganizationTypeToReviewsServiceMap[organizationType] as TOrganization,
  });

  return (
    <CallToActionSideBlock
      title="Оставить отзыв"
      text={textMap[organizationType]}
      buttonLabel={'Написать отзыв'}
      handleClick={handleClick}
      link={link}
    />
  );
});
